__turbopack_context__.v({
  "back": "mortgage-module-scss-module__UcdvZq__back",
  "cta": "mortgage-module-scss-module__UcdvZq__cta",
  "heading": "mortgage-module-scss-module__UcdvZq__heading",
  "input": "mortgage-module-scss-module__UcdvZq__input",
  "slider": "mortgage-module-scss-module__UcdvZq__slider",
});
